import { Injectable } from '@angular/core';
import {
  ExpressionEditorResult,
  ValidationResult,
  ValidationType,
} from 'libs/abc/ui-components/src/lib/core/src/abc-grid/abc-grid';

@Injectable({
  providedIn: 'root',
})
export class OPathValidationService {
  public validationResult: ValidationResult;
  public expressionEditorResult: ExpressionEditorResult;
  public validationType: ValidationType;
}
